<template>
  <footer class="site-footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="mb-12">
            <h3 class="footer-heading mb-4">About</h3>
            <p>
              Meet 'TheSoundOf.NET', your one-stop platform serving as a comprehensive collection of podcasts focusing on various aspects of .NET technology. Brace yourselves as thought leaders and experts simplify the complex dimensions of .NET, aiding you to grasp its profound usage in cloud and on-premise environments
            </p>
          </div>
        </div>
      </div>
      <div class="row pt-5 mt-5 text-center">
        <div class="col-md-12">
          <p>
            <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
            Copyright &copy;
            All rights reserved | This template is made with
            <i
              class="icon-heart-o"
              aria-hidden="true"
            ></i> by
            <a href="https://colorlib.com" target="_blank">Colorlib</a>
            <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>


<script>
export default {
  name: "PodcastsFooter"
};
</script>

